<template>
  <div>
    <Modal
      :width="500"
      :value="modalOpen"
      :title="modalData.title"
      :subtitle="modalData.subtitle"
      :cta-text="modalData.ctaText"
      :cancel-hidden="modalData.cancelHidden"
      @cancel="modalOpen = false"
      dialogIcon="danger"
      @confirm="confirmModal">
    </Modal>

    <ul class="tree" v-if="messageTree.length > 0">
      <LiveChatTreeNode @openModal="openModal" :node.sync="messageTree[0]" :parent="null"></LiveChatTreeNode>
    </ul>
  </div>
</template>

<script>
  import LiveChatTreeNode from "./LiveChatTreeNode.vue";
  import Modal from "@/components/custom/Modal.vue";
  import cloneDeep from "lodash/cloneDeep";

  export default {
    components: { LiveChatTreeNode, Modal },
    props: {
      messageTree: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        modalOpen: false,
        modalData: {},
        styleElement: null,
      };
    },
    computed: {
      tinymceCss() {
        return this.$store.state.tinymceCss;
      },
    },
    watch: {
      tinymceCss: {
        immediate: true,
        handler(newCss) {
          this.updateStyles(newCss);
        },
      },
    },
    beforeDestroy() {
      if (this.styleElement) {
        this.styleElement.remove();
        this.styleElement = null;
      }
    },
    methods: {
      updateStyles(css) {
        if (!this.styleElement) {
          this.styleElement = document.createElement("style");
          document.head.appendChild(this.styleElement);
        }

        this.styleElement.innerHTML = this.scopeCss(css, ".content-preview");
      },
      scopeCss(css, scopeSelector) {
        return css.replace(/(^|\})\s*([^{]+)/g, (match, closingBracket, selectors) => {
          if (closingBracket) {
            return `${closingBracket} ${selectors.split(",").map(sel => `${scopeSelector} ${sel.trim()}`).join(",")}`;
          }

          return `${scopeSelector} ${selectors}`;
        });
      },
      openModal(data) {
        this.modalOpen = true;
        this.modalData = data;
      },
      confirmModal() {
        this.modalOpen = false;
        if (this.modalData.delete) {
          const children = cloneDeep(this.modalData.parent.children);
          this.modalData.parent.children = [];

          this.$nextTick(() => {
            children.splice(this.modalData.index, 1);
            this.modalData.parent.children = children;
          });
        }
      },
    },
  };
</script>

<style lang="scss">
  @import "@/@core/preset/preset/shortcodes.scss";
</style>
